import request from '@/utils/request'

// 催办排序
export function cuibaiFilter() {
  return request({
    url: '/todo/cuiban/order/set?isAtTop=1',
    method: 'get',
    params: {}
  })
}
// 默认时间倒序
export function defaultFilter() {
  return request({
    url: '/todo/cuiban/order/set?isAtTop=0',
    method: 'get',
    params: {}
  })
}
// 时间正序
export function orderTimeFilter() {
  return request({
    url: '/todo/cuiban/order/set?isAtTop=2',
    method: 'get',
    params: {}
  })
}
// 查询是哪种排序
export function whatFilter() {
  return request({
    url: '/todo/cuiban/order/get',
    method: 'get',
    params: {}
  })
}
// 点击待办时的统计
export function cencus(todoId) {
  return request({
    url: '/todo/analysis/click',
    method: 'get',
    params: { todoId }
  })
}
// -----获取列表-----
// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/todo/account',
    method: 'post',
    data: {}
  })
}
// 待办/已办
export function getTodoList(data) {
  return request({
    url: '/todo/list',
    method: 'post',
    data
  })
}
// 龙湖费控 发起显示admin
export function getTodoListLHFK(data) {
  return request({
    url: '/todo/getFsscTodoTime',
    method: 'post',
    data
  })
}

// 发起
export function getInitiatorList(data) {
  return request({
    url: '/todo/initiator/list',
    method: 'post',
    data
  })
}

/**
 * @method 获取审批模板，即筛选关键字
 * @param {data} n { 0：已办，1：通知 }
 */
export function getTags(data) {
  return request({
    url: '/todo/tags',
    method: 'post',
    data
  })
}

// 获取通知的审批模板，及筛选关键字
export function getInitiatorTags(data) {
  return request({
    url: 'todo/initiator/tags',
    method: 'post',
    data
  })
}

/**
 * @method 旧版-获取系统分类信息
 * @param {number} n { 0: 代办, 1: 已办, 2: 发起 }
 * @return {json}
 */
export function getSystemList(n) {
  return request({
    url: '/todo/system/list',
    method: 'get',
    params: { type: n }
  })
}

// 删除代办
export function delDohalfData(todoId) {
  return request({
    url: '/api/delDohalfData',
    method: 'post',
    data: { todoId }
  })
}

// 标记已读
export function markRead(todoId, todoType) {
  return request({
    url: '/todo/mark-read',
    method: 'get',
    params: { todoId, todoType }
  })
}

// 标记已办
export function markDone(todoId, todoType) {
  return request({
    url: '/todo/mark-done',
    method: 'get',
    params: { todoId, todoType }
  })
}

/**
 * @method 获取发起未完成量
 * @param {string} token
 * @return {json}
 */
export function getInitiaorCount() {
  return request({
    url: '/api/initiaorCount',
    method: 'post',
    data: {}
  })
}

/**
 * @method 获取通知未阅读数量
 * @return {json}
 */
export function getNoticeCount() {
  return request({
    url: '/todo/count?todoType=1&isPc=1',
    method: 'get'
  })
}

// 龙信会话
export function setTodoCuiBan(data) {
  return request({
    url: '/todo/cuiban',
    method: 'post',
    data
  })
}
